import { Link, useParams } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getProductsByCategory } from '@/mocks/products';

export default function CategorySidebar() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <aside className="w-full lg:w-56 shrink-0">
      <h3 className="text-sm font-semibold text-foreground-900 mb-3 px-2">商品分类</h3>
      <nav className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0" aria-label="商品分类导航">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
              slug === cat.slug
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-700 hover:bg-background-100 hover:text-primary-500'
            }`}
          >
            <i className={`${cat.icon} text-base`}></i>
            {cat.name}
          </Link>
        ))}
      </nav>
    </aside>
  );
}